import { Helmet } from "react-helmet";
import LoginLayout from "../sections/login/loginLayout";
import { GetAuth } from "../context/auth/authProvider";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const LoginPage = () => {

    <Helmet>
        <title>Login</title>
    </Helmet>

    const authState = GetAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if(authState.currentUser){
            navigate('/records');
        }
    }, [authState.currentUser]);

    return(
        <>
            <LoginLayout />
        </>
    );
}

export default LoginPage;